import React, { useState } from 'react'
import { Query } from 'react-apollo'
import _ from 'lodash'
import { useQuery } from '@apollo/react-hooks'
import {
  Modal, AutoComplete, Radio,
} from 'antd'
import {
  Div, H3, Button, Loading, P,
} from 'konsys-ui'
import FileDownload from 'js-file-download'
import axios from 'axios'
import { status } from '../constants'
import { theme } from '../../../styles/_variables'
import { Wrapper, MoneyCollectionReportModal } from '../../../components/invoice-components'
import { INVOICE_LIST, INVOICE_PAYMENT_LIST } from '../../../constants/graphql/query'
import PERMISSION from '../../../constants/permissions'
import Table from './table'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import history from '../../../history'
import './style-css.css'

const { color } = theme

const ChequeReportModal = ({
  chequeReportModal, setChequeReportModal, isLoading, setIsLoading,
}) => {
  const [selectedNumber, setSelectedNumber] = useState()
  const [isCheque, setIsCheque] = useState(true)
  const [isSelect, setIsSelect] = useState(false)
  const {
    loading, data, error, refetch,
  } = useQuery(INVOICE_PAYMENT_LIST, { variables: { type: isCheque ? 'CHEQUE' : 'TRANSFER' } })
  if (loading && _.isEmpty(data)) return null
  return (
    <Modal
      title="พิมพ์รายงานการชำระเงิน"
      visible={chequeReportModal}
      destroyOnClose={true}
      onCancel={() => {
        setChequeReportModal(false)
        setSelectedNumber()
        setIsSelect(false)
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/invoice/chequeExcel?selectedNumber=${selectedNumber}&isCheque=${isCheque}`,
        }).then((resp) => {
          FileDownload(resp.data, `พิมพ์รายงานการชำระเงินด้วย${isCheque ? 'เช็ค' : 'การโอนเงิน'}หมายเลข ${selectedNumber}.xlsx`)
          setChequeReportModal(false)
          setSelectedNumber()
          setIsLoading(false)
          setIsSelect(false)
        })
      }}
      okButtonProps={{
        disabled: isLoading || _.isUndefined(selectedNumber) || !isSelect,
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='column'>
        <Radio.Group style={{ width: 'fit-content', margin: '16px 0' }} onChange={(e) => {
          setIsCheque(e.target.value)
          setSelectedNumber()
          refetch()
          setIsSelect(false)
        }} value={isCheque}>
          <Radio.Button value={true}>เช็ค</Radio.Button>
          <Radio.Button value={false}>โอนเงิน</Radio.Button>
        </Radio.Group>
        <Div width='100%' display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
          <P margin='16px 0'>เลือก{isCheque ? 'เช็ค' : 'เลขโอนเงิน'}</P>
          <AutoComplete
            style={{ width: 334 }}
            dataSource={_.uniq(data?.InvoicePaymentList?.lists.map(v => v.chequeNumber || v.bankNumber).filter(word => word.length > 0))}
            onSelect={(e) => {
              setSelectedNumber(e)
              setIsSelect(true)
            }}
            onSearch={(e) => {
              setSelectedNumber(e)
              refetch(isCheque ? { chequeNumber: e } : { bankNumber: e })
            }}
          />
        </Div>
      </Div>
    </Modal>
  )
}

const Index = () => {
  const [invoices, setInvoices] = useState([])
  const [moneyCollectionReportModal, setMoneyCollectionReportModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [chequeReportModal, setChequeReportModal] = useState(false)
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการใบวางบิล / ใบแจ้งหนี้</H3>
        <Div display='flex' flexDirection='row' justifyContent='space-between'>
        {/* <Button disabled={!_.includes(window.perms, PERMISSION.EXPORT_INVOICE)} inverse text='Export' onClick={() => download()} margin='0 16px 0 0' /> */}
        {/* <DynamicButtonLink link='/invoice/add' condition={_.includes(window.perms, PERMISSION.CREATE_INVOICE)} props={{ text: 'Create' }}/> */}
        <Button
            text='พิมพ์รายงานการชำระเงิน'
            onClick={() => {
              setChequeReportModal(true)
            }}
            margin='0 16px 0 0'
          />
        <Button
            // disabled={!_.includes(window.perms, PERMISSION.CREATE_INVOICE) || _.isEmpty(word) || !checkDelivered || _.isEmpty(check)}
            margin='0 16px 0 16px'
            disabled={!_.includes(window.perms, PERMISSION.VIEW_INVOICE)}
            text='พิมพ์รายงานการเก็บเงิน'
            onClick={() => {
              setMoneyCollectionReportModal(true)
            }}
          />
        <Button
          disabled={!_.includes(window.perms, PERMISSION.CREATE_BILL) || _.isEmpty(invoices)}
          text='สร้างใบปะหน้า'
          onClick={() => history.push({ pathname: '/bill/add', state: { invoices } })}
        />
        </Div>
      </Div>
      <MoneyCollectionReportModal
        modal={moneyCollectionReportModal}
        setModal={setMoneyCollectionReportModal}
      />
      <ChequeReportModal
      chequeReportModal={chequeReportModal}
      setChequeReportModal={setChequeReportModal}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      />
      <List invoices={invoices} setInvoices={setInvoices} />
    </Div>
  )
}

export const List = ({ invoices, setInvoices }) => {
  const [check, setCheck] = useState([])
  const [filtered, setFiltered] = useState()
  const [sorted, setSorted] = useState([{ id: 'updatedAt', desc: true }])
  const [current, setCurrent] = useState(0)

  return (
    <Wrapper overflow padding='0 0 40px 0'>
      <Query
        query={INVOICE_LIST}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 20,
          offset: current * 20,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >
        {
          ({
            data, loading, error, refetch,
          }) => {
            if (loading && _.isEmpty(data)) return <Loading center='true' />
            if (error) return <P>เกิดข้อผิดพลาด</P>
            return (
              <Div>
                <Table
                  data={data}
                  filtered={filtered}
                  current={current}
                  setCurrent={setCurrent}
                  refetch={refetch}
                  check={check}
                  setCheck={setCheck}
                  totalCount={data.InvoiceList.totalCount}
                  // checkDelivered={checkDelivered}
                  // setCheckDelivered={setCheckDelivered}
                  invoices={invoices}
                  setInvoices={setInvoices}
                  setFiltered={setFiltered}
                  setSorted={setSorted}
                  isCheckAll={!_.isEmpty(data.InvoiceList.lists) && !_.includes(data.InvoiceList.lists.map(v => _.includes(check, v.id)), false)}
                  checkDisabled={
                    _.isUndefined(filtered)
                    || !_.includes([status.WAITING, status.OVERDUE, status.BILLANDOVERDUE], filtered.status)
                    || ((_.isUndefined(filtered.jobNumber) || _.isEmpty(filtered.jobNumber)) && _.isUndefined(filtered.customerId))
                    || _.isUndefined(filtered.status)
                    || _.isEmpty(data.InvoiceList.lists)
                  }
                />
                {
                  loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
                }
              </Div>
            )
          }}
        </Query>
    </Wrapper>
  )
}
export default Index
